import { render, staticRenderFns } from "./ProviderEdit.vue?vue&type=template&id=0b27d1de&scoped=true&"
import script from "./ProviderEdit.vue?vue&type=script&lang=js&"
export * from "./ProviderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27d1de",
  null
  
)

export default component.exports